/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.PunchpassPaymentForm = class PunchpassPaymentForm {
  constructor(selector) {
    this.selector = selector;
    this.form = $(this.selector);

    // initialize Elements
    this.stripe = Stripe(stripeKey);
    this.elements = this.stripe.elements();
  }

  renderElements() {
    const _this = this;

    // design Elements
    const style = { base: {
      color: '#555555',
      fontFamily: 'Lato, Helvetica, Roboto, Arial, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      lineHeight: '24px',
      '::placeholder': { color: '#999'
    },
      ':-webkit-autofill': { color: '#fce883'
    }
    }
  };

    // create Elements
    const card = this.elements.create('card', {
      hidePostalCode: true,
      iconStyle: 'default',
      style
    });

    // mount Elements in current DOM
    card.mount('#card-element');

    // show error when required
    card.addEventListener('change', function(event) {
      if (event.error) {
        _this.showCardError(event.error.message);
      } else {
        _this.showCardError('');
      }
    });

    // catch submit action on the form
    return this.form.on('submit', function(event) {
      // don't catch action if the token has been generated
      if (_this.form.find('input[name="stripeToken"]').length) { return; }

      event.preventDefault();

      // make sure that the submit button is disabled
      // (useful if the form is submitted with <Enter>)
      Ladda.create(_this.form.find('button[type="submit"]')[0]).start();

      // create Stripe token for the card
      return _this.stripe.createToken(card).then(function(result) {
        if (result.error) {
          // show raised error and re-enable submit buttons
          _this.showCardError(result.error.message);
          return Ladda.stopAll();
        } else {
          // append stripToken input to form and submit
          _this.addTokenInput(result.token, _this.form.attr('id'));
          return _this.form.submit();
        }
      });
    });
  }

  // function used to show errors for the Elements form
  showCardError(message) {
    return this.form.find('#card-errors').html(message);
  }

  // function used to append stripeToken input to form
  addTokenInput(token, formId) {
    return $('<input>').attr({
      type: 'hidden',
      name: 'stripeToken',
      value: token.id}).appendTo(this.form);
  }
};

$(document).ready(function() {
  if (!($('[data-behavior~=punchpass-payment-form]').length > 0)) { return; }
  const punchpassPaymentForm =
    new App.PunchpassPaymentForm($('[data-behavior~=punchpass-payment-form]'));
  return punchpassPaymentForm.renderElements();
});
